import { stats } from "@/mocks/site";

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
            蘑菇tv成品人平台数据
          </h2>
          <p className="text-primary-100 text-sm md:text-base max-w-lg mx-auto">
            用心服务每一位创作者，数据见证我们的成长
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 font-heading mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-primary-100 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}